// Utility functions for notification styling and formatting

export const getNotificationTypeInfo = (type, priority = 'normal') => {
 const typeConfig = {
 'REQUEST': {
 label: 'Yêu cầu',
 icon: 'fas fa-hand-paper',
 color: '#4c85e3', // Blue
 bgColor: '#eaf1fe',
 borderColor: '#2e79c5'
 },
 'LEAVE_REQUEST': {
 label: 'Xin nghỉ phép',
 icon: 'fas fa-calendar-times',
 color: '#3d78de', // Facebook Blue
 bgColor: '#eaf1fe',
 borderColor: '#3d78de'
 },
 'APPROVAL': {
 label: 'Phê duyệt',
 icon: 'fas fa-check-circle',
 color: '#3d78de', // Facebook Blue
 bgColor: '#eaf1fe',
 borderColor: '#3d78de'
 },
 'SYSTEM': {
 label: 'Hệ thống',
 icon: 'fas fa-cog',
 color: '#4085a5', // Blue Grey
 bgColor: '#e7f0f7',
 borderColor: '#4085a5'
 },
 'INCIDENT': {
 label: 'Sự cố',
 icon: 'fas fa-exclamation-triangle',
 color: '#ef4444', // Red
 bgColor: '#fbeff2',
 borderColor: '#ef4444'
 },
 'REPORT': {
 label: 'Báo cáo',
 icon: 'fas fa-chart-bar',
 color: '#3d78de', // Facebook Blue
 bgColor: '#eaf1fe',
 borderColor: '#3d78de'
 },
 'TASK': {
 label: 'Nhiệm vụ',
 icon: 'fas fa-tasks',
 color: '#2e79c5', // Light Blue
 },
 'EVALUATION': {
 label: 'Đánh giá',
 icon: 'fas fa-clipboard-check',
 color: '#672fca', // Deep Purple
 bgColor: '#e8f4f7',
 borderColor: '#2e79c5'
 },
 'INFO': {
 label: 'Thông tin',
 icon: 'fas fa-info-circle',
 color: '#2eb6c6', // Cyan
 bgColor: '#dcf6f6',
 borderColor: '#2eb6c6'
 },
 'COMMENT': {
 label: 'Bình luận',
 icon: 'fas fa-comment',
 color: '#3d78de', // Facebook Blue
 bgColor: '#eaf1fe',
 borderColor: '#3d78de'
 },
 'COLLABORATION': {
 label: 'Cộng tác',
 icon: 'fas fa-users',
 color: '#3d78de', // Facebook Blue
 bgColor: '#eaf1fe',
 borderColor: '#3d78de'
 },
 'VEHICLE_EXPIRED': {
 label: 'Xe hết hạn',
 icon: 'fas fa-exclamation-triangle',
 color: '#dc2626', // Dark Red
 bgColor: '#fbeff2',
 borderColor: '#dc2626'
 },
 'VEHICLE_EXPIRING': {
 label: 'Xe sắp hết hạn',
 icon: 'fas fa-exclamation-triangle',
 color: '#d97706', // Yellow/Amber
 bgColor: '#f9f9ed',
 borderColor: '#d97706'
 },
 'VEHICLE_MAINTENANCE': {
 label: 'Bảo dưỡng xe',
 icon: 'fas fa-tools',
 color: '#3786d2', // Blue
 bgColor: '#eaf1fe',
 borderColor: '#3786d2'
 },
 'VEHICLE_FUEL': {
 label: 'Nhiên liệu xe',
 icon: 'fas fa-gas-pump',
 color: '#3d78de', // Facebook Blue
 bgColor: '#eaf1fe',
 borderColor: '#3d78de'
 },
 'VEHICLE_INSURANCE': {
 label: 'Bảo hiểm xe',
 icon: 'fas fa-shield-alt',
 color: '#8227aa', // Purple
 bgColor: '#f3e3f7',
 borderColor: '#8227aa'
 },
 'HR_CONTRACT_EXPIRED': {
 label: 'HĐ hết hạn',
 icon: 'fas fa-file-contract',
 color: '#dc2626',
 bgColor: '#fbeff2',
 borderColor: '#dc2626'
 },
 'HR_CONTRACT_EXPIRING': {
 label: 'HĐ sắp hết hạn',
 icon: 'fas fa-clock',
 color: '#d28637',
 bgColor: '#f7f1e8',
 borderColor: '#d28637'
 },
 'HR_MISSING_DATA': {
 label: 'Thiếu dữ liệu HR',
 icon: 'fas fa-exclamation-circle',
 color: '#d29837',
 bgColor: '#faf3e6',
 borderColor: '#d29837'
 },
 'HR_BIRTHDAY': {
 label: 'Sinh nhật NV',
 icon: 'fas fa-birthday-cake',
 color: '#d62e73',
 bgColor: '#fae6ed',
 borderColor: '#d62e73'
 },
 'HR_MISSING_DOCUMENT': {
 label: 'Thiếu tài liệu',
 icon: 'fas fa-folder-open',
 color: '#d9795c',
 bgColor: '#fbebe7',
 borderColor: '#d9795c'
 },
 'HR_GENERAL': {
 label: 'Nhân sự',
 icon: 'fas fa-user-tie',
 color: '#2f6bd8',
 bgColor: '#eaf1fe',
 borderColor: '#2f6bd8'
 }
 };

 const priorityConfig = {
 'urgent': {
 intensity: 'urgent',
 pulseColor: '#d13955',
 shadowIntensity: '0 0 15px'
 },
 'high': {
 intensity: 'high',
 pulseColor: '#d36542',
 shadowIntensity: '0 0 10px'
 },
 'normal': {
 intensity: 'normal',
 pulseColor: null,
 shadowIntensity: '0 0 5px'
 },
 'low': {
 intensity: 'low',
 pulseColor: null,
 shadowIntensity: '0 0 3px'
 }
 };

 const baseConfig = typeConfig[type] || typeConfig['SYSTEM'];
 const priorityInfo = priorityConfig[priority] || priorityConfig['normal'];

 return {
 ...baseConfig,
 priority: priorityInfo,
 className: `notification-type-${type?.toLowerCase() || 'system'} notification-priority-${priority}`
 };
};

export const getNotificationTypeLabel = (type) => {
 const typeLabels = {
 'REQUEST': 'Yêu cầu',
 'LEAVE_REQUEST': 'Xin nghỉ phép',
 'APPROVAL': 'Phê duyệt',
 'SYSTEM': 'Hệ thống',
 'INCIDENT': 'Sự cố',
 'REPORT': 'Báo cáo',
 'TASK': 'Nhiệm vụ',
 'INFO': 'Thông tin',
 'COMMENT': 'Bình luận',
 'COLLABORATION': 'Cộng tác',
 'VEHICLE_EXPIRED': 'Xe hết hạn',
 'VEHICLE_EXPIRING': 'Xe sắp hết hạn',
 'VEHICLE_MAINTENANCE': 'Bảo dưỡng xe',
 'VEHICLE_FUEL': 'Nhiên liệu xe',
 'VEHICLE_INSURANCE': 'Bảo hiểm xe',
 'HR_CONTRACT_EXPIRED': 'HĐ hết hạn',
 'HR_CONTRACT_EXPIRING': 'HĐ sắp hết hạn',
 'HR_MISSING_DATA': 'Thiếu dữ liệu HR',
 'HR_BIRTHDAY': 'Sinh nhật NV',
 'HR_MISSING_DOCUMENT': 'Thiếu tài liệu',
 'HR_GENERAL': 'Nhân sự'
 };
 
 return typeLabels[type] || 'Hệ thống';
};

export const getPriorityLabel = (priority) => {
 const priorityLabels = {
 'urgent': 'Khẩn cấp',
 'high': 'Cao',
 'normal': 'Bình thường',
 'low': 'Thấp'
 };
 
 return priorityLabels[priority] || 'Bình thường';
};

export const formatNotificationTime = (timestamp) => {
 const date = new Date(timestamp);
 const now = new Date();
 const diffInMinutes = Math.floor((now - date) / (1000 * 60));
 
 if (diffInMinutes < 1) {
 return 'Vừa xong';
 } else if (diffInMinutes < 60) {
 return `${diffInMinutes} phút trước`;
 } else if (diffInMinutes < 1440) { // 24 hours
 const hours = Math.floor(diffInMinutes / 60);
 return `${hours} giờ trước`;
 } else if (diffInMinutes < 10080) { // 7 days
 const days = Math.floor(diffInMinutes / 1440);
 return `${days} ngày trước`;
 } else {
 return date.toLocaleDateString('vi-VN', {
 year: 'numeric',
 month: 'short',
 day: 'numeric',
 hour: '2-digit',
 minute: '2-digit'
 });
 }
};

// Auto-detect notification type based on message content
export const detectNotificationType = (message, currentType) => {
 if (currentType && currentType !== 'SYSTEM') {
 return currentType; // Don't override if already set
 }

 const lowerMessage = message.toLowerCase();

 // HR-related notifications (detect from message content)
 if (lowerMessage.includes('hợp đồng hết hạn') || lowerMessage.includes('hđ hết hạn')) {
 return 'HR_CONTRACT_EXPIRED';
 }
 if (lowerMessage.includes('hđ sắp hết hạn') || lowerMessage.includes('hợp đồng sắp hết')) {
 return 'HR_CONTRACT_EXPIRING';
 }
 if (lowerMessage.includes('thiếu mã bhxh') || lowerMessage.includes('thiếu cccd') || lowerMessage.includes('thiếu cmnd')) {
 return 'HR_MISSING_DATA';
 }
 if (lowerMessage.includes('sinh nhật') && (lowerMessage.includes('nhân viên') || lowerMessage.includes(''))) {
 return 'HR_BIRTHDAY';
 }
 
 // Vehicle-related notifications
 if (lowerMessage.includes('xe ') || lowerMessage.includes('biển số')) {
 // Check "sắp hết hạn"FIRST before "hết hạn"
 if ((lowerMessage.includes('sắp hết hạn') || lowerMessage.includes('sẽ hết hạn')) && (lowerMessage.includes('đăng kiểm') || lowerMessage.includes('kiểm định'))) {
 return 'VEHICLE_EXPIRING';
 }
 if (lowerMessage.includes('hết hạn') && (lowerMessage.includes('đăng kiểm') || lowerMessage.includes('kiểm định'))) {
 return 'VEHICLE_EXPIRED';
 }
 if ((lowerMessage.includes('sắp hết hạn') || lowerMessage.includes('sẽ hết hạn')) && lowerMessage.includes('bảo hiểm')) {
 return 'VEHICLE_INSURANCE';
 }
 if (lowerMessage.includes('bảo dưỡng') || lowerMessage.includes('maintenance')) {
 return 'VEHICLE_MAINTENANCE';
 }
 if (lowerMessage.includes('nhiên liệu') || lowerMessage.includes('xăng') || lowerMessage.includes('dầu')) {
 return 'VEHICLE_FUEL';
 }
 if (lowerMessage.includes('bảo hiểm')) {
 return 'VEHICLE_INSURANCE';
 }
 }

 // Other types
 if (lowerMessage.includes('nghỉ phép') || lowerMessage.includes('leave')) {
 return 'LEAVE_REQUEST';
 }
 if (lowerMessage.includes('phê duyệt') || lowerMessage.includes('approval')) {
 return 'APPROVAL';
 }
 if (lowerMessage.includes('sự cố') || lowerMessage.includes('incident') || lowerMessage.includes('lỗi')) {
 return 'INCIDENT';
 }
 if (lowerMessage.includes('báo cáo') || lowerMessage.includes('report')) {
 return 'REPORT';
 }
 if (lowerMessage.includes('nhiệm vụ') || lowerMessage.includes('task')) {
 return 'TASK';
 }
 if (lowerMessage.includes('đánh giá') || lowerMessage.includes('evaluation') || lowerMessage.includes('cấp trên') || lowerMessage.includes('quản lý đánh giá')) {
 return 'EVALUATION';
 }
 if (lowerMessage.includes('bình luận') || lowerMessage.includes('comment')) {
 return 'COMMENT';
 }
 if (lowerMessage.includes('hệ thống') || lowerMessage.includes('system') || lowerMessage.includes('cập nhật') || lowerMessage.includes('bảo trì')) {
 return 'SYSTEM';
 }

 return currentType || 'SYSTEM';
};

// Auto-detect priority based on message content
export const detectNotificationPriority = (message, type, currentPriority) => {
 if (currentPriority && currentPriority !== 'normal') {
 return currentPriority; // Don't override if already set
 }

 const lowerMessage = message.toLowerCase();

 // HR contract expired is urgent
 if (type === 'HR_CONTRACT_EXPIRED') {
 return 'urgent';
 }
 // HR contract expiring is high
 if (type === 'HR_CONTRACT_EXPIRING') {
 return 'high';
 }
 
 // Vehicle expired is always urgent
 if (type === 'VEHICLE_EXPIRED' || lowerMessage.includes('hết hạn')) {
 return 'urgent';
 }
 
 // Vehicle expiring is high priority
 if (type === 'VEHICLE_EXPIRING' || lowerMessage.includes('sắp hết hạn')) {
 return 'high';
 }
 
 // Incidents are usually high priority
 if (type === 'INCIDENT' || lowerMessage.includes('sự cố') || lowerMessage.includes('lỗi nghiêm trọng')) {
 return 'high';
 }
 
 // Urgent keywords
 if (lowerMessage.includes('khẩn cấp') || lowerMessage.includes('urgent') || lowerMessage.includes('gấp')) {
 return 'urgent';
 }
 
 // High priority keywords
 if (lowerMessage.includes('quan trọng') || lowerMessage.includes('important') || lowerMessage.includes('ưu tiên')) {
 return 'high';
 }
 
 // Evaluation notifications
 if (type === 'EVALUATION') {
 // Đánh giá từ cấp trên là high priority
 if (lowerMessage.includes('cấp trên') || lowerMessage.includes('quản lý đánh giá')) {
 return 'high';
 }
 // Các đánh giá khác là normal priority
 return 'normal';
 }
 
 return currentPriority || 'normal';
};